import { SemboMarket } from '../../../apps/explore/utils/markets';

export const DEFAULT_SEMBO_MARKET: SemboMarket = {
  host: 'www.sembo.com',
  lang: 'en',
  countryISO: 'US',
};

export const TRIP_PLANNER_EXTRA_QUERY_PARAMS_MAP: Record<
  string,
  Record<string, string>
> = {
  'www.stenaline.se': {
    'affiliate-id': '850001',
    utm_source: 'StenaLineSE',
    utm_medium: 'WL',
    utm_campaign: 'WL-SE-StenaLine-SharedSearcher',
  },
  'www.stenaline.de': {
    'affiliate-id': '850003',
    utm_source: 'StenaLineDE',
    utm_medium: 'WL',
    utm_campaign: 'WL-DE-StenaLine-SharedSearcher',
  },
  'www.stenaline.pl': {
    'affiliate-id': '850014',
    utm_source: 'StenaLinePL',
    utm_medium: 'WL',
    utm_campaign: 'WL-PL-StenaLine-SharedSearcher',
  },
  'www.stenaline.ie': {
    'affiliate-id': '850008',
    utm_source: 'StenaLineIE',
    utm_medium: 'WL',
    utm_campaign: 'WL-IE-StenaLine-SharedSearcher',
  },
  'www.stenaline.no': {
    'affiliate-id': '850013',
    utm_source: 'StenaLineNO',
    utm_medium: 'WL',
    utm_campaign: 'WL-NO-StenaLine-SharedSearcher',
  },
  'www.stenaline.fi': {
    'affiliate-id': '850015',
    utm_source: 'StenaLineFI',
    utm_medium: 'WL',
    utm_campaign: 'WL-FI-StenaLine-SharedSearcher',
  },
  'www.stenaline.co.uk': {
    'affiliate-id': '850016',
    utm_source: 'StenaLineUK',
    utm_medium: 'WL',
    utm_campaign: 'WL-UK-StenaLine-SharedSearcher',
  },
};
